module.exports = "<span class=\"text-center\">\n  <img *ngIf=\"showlogo\" src=\"assets/elzeviro3logo.png\">\n  <div class=\"strike\">\n    <span>{{version}}</span>\n  </div>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logo/logo.component.html
// module id = ./src/app/components/logo/logo.component.html
// module chunks = main